import React, { useState } from 'react';
import { Card, Col, Container, Form, Row, Button, Image } from 'react-bootstrap';
import PageSubTitle from '../Components/Layout/PageSubTitle';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

import CheckOutData from '../data/food_data.json';

export default function CheckOut() {
    const [paymentMethod, setPaymentMethod] = useState("cash");
    const [isOrderConfirmed, setIsOrderConfirmed] = useState(false);

    const [shippingInfo, setShippingInfo] = useState({
        firstName: "",
        lastName: "",
        email: "",
        number: "",
        address: ""
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setShippingInfo(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const isFormValid = 
        shippingInfo.firstName.trim() !== "" &&
        shippingInfo.lastName.trim() !== "" &&
        shippingInfo.email.trim() !== "" &&
        shippingInfo.number.trim() !== "" &&
        shippingInfo.address.trim() !== "";

    const handlePlaceOrder = (e) => {
        e.preventDefault();
        setIsOrderConfirmed(true);
        localStorage.removeItem('cart_quantities');
        localStorage.removeItem('cart_applied_promo');
    };

    const [quantities] = useState(() => {
        const saved = localStorage.getItem('cart_quantities');
        return saved ? JSON.parse(saved) : CheckOutData.checkoutFoodData.map(() => 1);
    });

    const [appliedPromo] = useState(() => {
        return localStorage.getItem('cart_applied_promo') || '';
    });

    const subtotal = CheckOutData.checkoutFoodData.reduce((sum, item, index) => {
        const price = parseFloat(item.foodPrice.replace('$', '')) || 0;
        return sum + price * (quantities[index] || 1);
    }, 0);

    const discount = appliedPromo === 'FOOD50' ? subtotal * 0.5 : 0.00;
    const grandTotal = Math.max(0, subtotal - discount);

    const handlePaymentChange = (e) => {
        setPaymentMethod(e.target.value);
    };

    return (
        <>
            <PageSubTitle pagename="CheckOut" />
            <motion.section initial={{opacity: 0}} whileInView={{opacity: 1}} transition={{duration: 0.5}} viewport={{once: true}} className='section'>
                <Container>
                    {isOrderConfirmed ? (
                        <Row className='justify-content-center'>
                            <Col md={8} lg={6}>
                                <motion.div 
                                    initial={{opacity: 0, scale: 0.9}} 
                                    animate={{opacity: 1, scale: 1}} 
                                    transition={{duration: 0.5}}
                                    className="text-center p-5 card border rounded-4 shadow-sm"
                                >
                                    <div className="mb-4">
                                        <i className="ri-checkbox-circle-fill text-success" style={{ fontSize: '80px' }}></i>
                                    </div>
                                    <h2 className="fw-semibold mb-3">Order Confirmed!</h2>
                                    <p className="text-muted fs-18 mb-4">
                                        Thank you, <strong>{shippingInfo.firstName} {shippingInfo.lastName}</strong>! Your order has been placed successfully and your delicious food is on its way to your doorstep.
                                    </p>
                                    <div className="bg-light border p-3 rounded-3 mb-4 text-start">
                                        <div className="d-flex justify-content-between mb-2">
                                            <span className="text-muted">Payment Method:</span>
                                            <span className="fw-medium text-capitalize">{paymentMethod === 'card' ? 'Credit/Debit Card' : 'Cash on Delivery'}</span>
                                        </div>
                                        <div className="d-flex justify-content-between mb-2">
                                            <span className="text-muted">Delivery Address:</span>
                                            <span className="fw-medium text-end" style={{maxWidth: '200px'}}>{shippingInfo.address}</span>
                                        </div>
                                        <hr className="my-2" />
                                        <div className="d-flex justify-content-between fs-18 fw-semibold text-danger">
                                            <span>Total Paid:</span>
                                            <span>${grandTotal.toFixed(2)}</span>
                                        </div>
                                    </div>
                                    <Link to="/home" className="btn btn-danger w-100 py-2 fs-18 rounded-3">
                                        Continue Ordering
                                    </Link>
                                </motion.div>
                            </Col>
                        </Row>
                    ) : (
                        <Row>
                        <Col lg={6} xl={7}>
                        <motion.div initial={{opacity: 0,x: -20}} whileInView={{opacity: 1,x: 0}} transition={{duration: 0.5}}>
                            <Card className='border'>
                                <Card.Body>
                                    <h5 className='mb-4'>Shipping Information</h5>
                                    <Form className='mb-xl-4'>
                                        <Row>
                                            <Col sm={6} lg={12} xl={6}>
                                                <div className="mb-3">
                                                    <Form.Label>First Name</Form.Label>
                                                    <Form.Control type="text" name="firstName" value={shippingInfo.firstName} onChange={handleInputChange} placeholder="Enter first name..." />
                                                </div>
                                            </Col>
                                            <Col sm={6} lg={12} xl={6}>
                                                <div className="mb-3">
                                                    <Form.Label>Last Name</Form.Label>
                                                    <Form.Control type="text" name="lastName" value={shippingInfo.lastName} onChange={handleInputChange} placeholder="Enter last name..." />
                                                </div>
                                            </Col>
                                            <Col sm={6} lg={12} xl={6}>
                                                <div className="mb-3">
                                                    <Form.Label>Your Email</Form.Label>
                                                    <Form.Control type="email" name="email" value={shippingInfo.email} onChange={handleInputChange} placeholder="Enter email..." />
                                                </div>
                                            </Col>
                                            <Col sm={6} lg={12} xl={6}>
                                                <div className="mb-3">
                                                    <Form.Label>Your Number</Form.Label>
                                                    <Form.Control type="number" name="number" value={shippingInfo.number} onChange={handleInputChange} placeholder="Enter number..." />
                                                </div>
                                            </Col>
                                            <Col xl={12}>
                                                <div className="mb-3">
                                                    <Form.Label>Your Address</Form.Label>
                                                    <Form.Control as="textarea" rows={2} name="address" value={shippingInfo.address} onChange={handleInputChange} placeholder="Enter address..." />
                                                </div>
                                            </Col>
                                        </Row>
                                    </Form>
                                    <div className="d-flex justify-content-center flex-wrap gap-3">
                                        <div className={`radio-btn ${paymentMethod === "cash" ? "radio-active" : ""}`} onClick={() => setPaymentMethod("cash")}>
                                            <Form.Check type="radio" label="Cash on Delivery" name="payment"
                                                value="cash" checked={paymentMethod === "cash"} onChange={handlePaymentChange}
                                            />
                                        </div>
                                        <div className={`radio-btn ${paymentMethod === "card" ? "radio-active" : ""}`} onClick={() => setPaymentMethod("card")}>
                                            <Form.Check type="radio" label="Credit/Debit Cards" name="payment"
                                                value="card" checked={paymentMethod === "card"} onChange={handlePaymentChange}
                                            />
                                        </div>
                                    </div>

                                    <div className="mt-3">
                                        {paymentMethod === "card" && (
                                            <Form>
                                                <Row>
                                                    <Col md={12}>
                                                        <div className="mb-3">
                                                            <Form.Label>Card Number</Form.Label>
                                                            <Form.Control type="text" placeholder="Enter card number" />
                                                        </div>
                                                    </Col>
                                                    <Col md={12}>
                                                        <div className="mb-3">
                                                            <Form.Label>Cardholder Name</Form.Label>
                                                            <Form.Control type="text" placeholder="Enter name" />
                                                        </div>
                                                    </Col>
                                                    <Col md={6}>
                                                        <div className="mb-3">
                                                            <Form.Label>Expiry Date</Form.Label>
                                                            <Form.Control type="text" placeholder="MM/YY" />
                                                        </div>
                                                    </Col>
                                                    <Col md={6}>
                                                        <div className="mb-3">
                                                            <Form.Label>CVV</Form.Label>
                                                            <Form.Control type="password" placeholder="CVV" />
                                                        </div>
                                                    </Col>
                                                </Row>
                                                <Button variant="danger" className="w-100" disabled={!isFormValid} onClick={handlePlaceOrder}>Pay Now</Button>
                                            </Form>
                                        )}
                                        {paymentMethod === "cash" && (
                                            <Button variant="danger" className="w-100" disabled={!isFormValid} onClick={handlePlaceOrder}>Place Order</Button>
                                        )}
                                    </div>
                                </Card.Body>
                            </Card>
                        </motion.div>
                        </Col>

                        <Col lg={6} xl={5}>
                        <motion.div initial={{opacity: 0,x: 20}} whileInView={{opacity: 1,x: 0}} transition={{duration: 0.5}}>
                            <Card className='border'>
                                <Card.Body>
                                    <h5 className='mb-0'>Review Your Items</h5>
                                    {CheckOutData.checkoutFoodData.map((data, i) => (
                                        <div className="d-flex align-items-center checkout-item mt-4" key={i}>
                                            <div className="flex-shrink-0">
                                                <div className='bg-light border checkout-food-img px-3 py-2 rounded-3'>
                                                    {/* <img src={coImg} alt="" className='png-img-shadow-sm' /> */}
                                                    <Image src={require(`../images/menu-item/${data.foodImg}`)} alt="" className='png-img-shadow-sm' />
                                                </div>
                                            </div>
                                            <div className="flex-grow-1 ms-4">
                                                <h5 className='mb-0 fw-semibold'>{data.foodName}</h5>
                                                <p className='text-muted fs-18 mb-2'>{data.foodSubText}</p>
                                                <div className='d-flex align-items-center flex-wrap justify-content-between gap-2'>
                                                    <h6 className='text-muted mb-0 mb-0'>Quantity: {quantities[i] || 1}</h6>
                                                    <h5 className='text-danger mb-0 fw-semibold mb-0'>
                                                        ${(parseFloat(data.foodPrice.replace('$', '')) * (quantities[i] || 1)).toFixed(2)}
                                                    </h5>
                                                </div>
                                            </div>
                                        </div>
                                    ))}

                                    <hr className='my-4' />

                                    <div className="d-flex justify-content-between mb-3">
                                        <h6 className='fw-normal fs-20 text-muted'>Subtotal</h6>
                                        <h6 className='fw-medium fs-20'>${subtotal.toFixed(2)}</h6>
                                    </div>
                                    <div className="d-flex justify-content-between mb-3">
                                        <h6 className='fw-normal fs-20 text-muted'>Discount {appliedPromo && `(${appliedPromo})`}</h6>
                                        <h6 className='fw-medium text-muted fs-20'>- ${discount.toFixed(2)}</h6>
                                    </div>
                                    <hr />
                                    <div className="d-flex justify-content-between">
                                        <h5 className='fw-semibold mb-0'>Grand Total</h5>
                                        <h5 className='fw-semibold mb-0'>${grandTotal.toFixed(2)}</h5>
                                    </div>
                                </Card.Body>
                            </Card>
                            </motion.div>
                        </Col>
                    </Row>
                    )}
                </Container>
            </motion.section>
        </>
    )
}
